compiler('[dynamic-modal]', (element) => {
  const modalUrl = element.getAttribute('dynamic-modal');
  const defaultTitle = element.getAttribute("modal-default-title")
  const defaultBody = element.getAttribute("modal-default-body")

  element.addEventListener('click', (event) => {
    event.preventDefault();

    const modalOptions = {}
    if(defaultTitle != null) {
      modalOptions.default_title = defaultTitle
    }
    if(defaultBody != null) {
      modalOptions.default_body = defaultBody
    }
    DynamicModal.openModal(modalUrl, true, modalOptions);
  });
});
